import {Directive, ElementRef, Input, Renderer2} from '@angular/core';

export type ElementPosFunction = (element: ElementRef, elementHeight: number, containerElement: HTMLElement) => {top?: number, bottom?: number} | null;

@Directive({
  selector: '[libPinnedElement]'
})
export class PinnedElementDirective {
  private elementHeight!: number;
  @Input() elementPosFunction?: ElementPosFunction;
  public containerElement!: HTMLElement;
  public pinToTop = true;
  constructor(private elementRef: ElementRef, private renderer: Renderer2) {
    this.renderer.setStyle(this.elementRef.nativeElement, 'position', `sticky`);
    this.renderer.setStyle(this.elementRef.nativeElement, 'z-index', 10);
    this.renderer.setStyle(this.elementRef.nativeElement, 'transition', `top 220ms ease-in`);
  }
  init() {
    this.elementHeight = this.elementRef.nativeElement.getBoundingClientRect().height * -1;
    this.resetPin();
  }
  pinElement() {
    const pos = this.elementPosFunction?.(this.elementRef, this.elementHeight, this.containerElement);
    if (!pos) { // Default
      this.renderer.setStyle(this.elementRef.nativeElement, 'top', `${0}px`);
      return;
    }
    if (pos.top || pos.top === 0) {
      this.renderer.setStyle(this.elementRef.nativeElement, 'top', `${pos.top}px`);
      this.renderer.setStyle(this.elementRef.nativeElement, 'bottom', `unset`);
      return;
    }
    if (pos.bottom || pos.bottom === 0) {
      this.renderer.setStyle(this.elementRef.nativeElement, 'bottom', `${pos.bottom}px`);
      this.renderer.setStyle(this.elementRef.nativeElement, 'top', `unset`);
      return;
    }
  }
  resetPin() {
    if (this.pinToTop) {
      this.renderer.setStyle(this.elementRef.nativeElement, 'top', `${this.elementHeight ?? -500}px`);
    } else {
      this.renderer.setStyle(this.elementRef.nativeElement, 'bottom', `${0}px`);
    }
  }
}
